import { useTheme } from "@/providers/ThemeProvider";
import { useNavigate } from "@/lib/browserRouter";

export default function Logo({ size, justify, white }) {
  const width = size === "sm" ? "w-40 invert" : "w-56 invert";
  const { theme } = useTheme();
  const color = white
    ? `${import.meta.env.VITE_MEDIA_URL}u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/xkaCBI0453608.svg`
    : `${import.meta.env.VITE_MEDIA_URL}u/xvMWv9TeqRbfe0S75EQu53KtBf33/Pictures/fYhIne5427759.svg`;

  const navigate = useNavigate();

  const navigateToHome = () => navigate("/");

  return (
    <div role="button" onClick={navigateToHome}>
      <img
        className={width}
        src={color}
        alt="logo"
      />
    </div>
  );
}
